import { render, staticRenderFns } from "./userProfileCircle.vue?vue&type=template&id=25263e17&"
import script from "./userProfileCircle.vue?vue&type=script&lang=js&"
export * from "./userProfileCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports